// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__2DyYF","marginBottom":"index_marginBottom__m3eoA"};